import {
  SEND_PAYMENT_LINK_LOADING,
  SEND_PAYMENT_LINK_SUCCESS,
  SEND_PAYMENT_LINK_FAILED,
} from "../types";

interface PaymentLinkState {
  loading: boolean;
  data: any;
  error: string | null;
}

const initialState: PaymentLinkState = {
  loading: false,
  data: null,
  error: null,
};

const sendPaymentLinkReducer = (
  state = initialState,
  action: any
): PaymentLinkState => {
  switch (action.type) {
    case SEND_PAYMENT_LINK_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case SEND_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case SEND_PAYMENT_LINK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default sendPaymentLinkReducer;
